import { useEffect } from "react";

function GoogleCallbackPage() {
  useEffect(() => {
    try {
      const hash = new URLSearchParams(window.location.hash.substring(1));
      const idToken = hash.get("id_token");
      // Mobil uygulamadan açılan giriş: kimlik bilgisini uygulamaya geri gönder
      if (hash.get("state") === "app") {
        const credential = idToken ? encodeURIComponent(idToken) : "";
        window.location.replace(`mutfacik://google-auth#credential=${credential}`);
        return;
      }
      if (idToken && window.opener) {
        window.opener.postMessage(
          { type: "GOOGLE_ID_TOKEN", credential: idToken },
          window.location.origin
        );
      }
    } catch {
      // hata olsa bile kapat
    }
    window.close();
  }, []);

  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
      <span>Yükleniyor...</span>
    </div>
  );
}

export default GoogleCallbackPage;
